import { ReferenceBusinessId, ReferenceContactId } from "@sp-crm/core";
import type { ActivityRowRelatedEntity } from "components/details-page-v-next/activity-rows";
import { goalMetricItemHref } from "./goal-metric-item";

interface ActivityOrganization {
    businessId: ReferenceBusinessId;
    name: string;
}

interface ActivityContact {
    contactId: ReferenceContactId;
    name: string;
}

export const organizationRelation = (
    organization: ActivityOrganization | null,
): ActivityRowRelatedEntity | null =>
    organization
        ? {
              href: goalMetricItemHref({
                  kind: "referenceBusiness",
                  entityId: organization.businessId,
              }),
              name: organization.name,
          }
        : null;

export const contactRelations = (
    contacts: ActivityContact[],
): ActivityRowRelatedEntity[] =>
    contacts.map(contact => ({
        href: goalMetricItemHref({
            kind: "referenceContact",
            entityId: contact.contactId,
        }),
        name: contact.name,
    }));
